import { render } from "./London.vue?vue&type=template&id=b1855678"
import script from "./London.vue?vue&type=script&lang=js"
export * from "./London.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__